import { ShortlistsTable, ShortlistFilterByOwnership } from '@statsbomb/kitbag-shortlists';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SHORTLISTS_OWNERSHIP_FILTER } from '@/consts/searchKeys';

export const RecruitmentListOverviewPage = () => {
  const navigate = useNavigate();

  const {
    i18n: { language: locale },
  } = useTranslation();

  const [searchParams, setSearchParams] = useSearchParams({
    [SHORTLISTS_OWNERSHIP_FILTER]: ShortlistFilterByOwnership.ALL,
  });

  const selectedOwnershipFilter: ShortlistFilterByOwnership = searchParams.get(
    SHORTLISTS_OWNERSHIP_FILTER,
  ) as ShortlistFilterByOwnership;

  return (
    <div className="p-2 h-full">
      <ShortlistsTable
        onLinkClick={(shortlistId: string) => navigate(`../${shortlistId}/players`)}
        selectedOwnershipFilter={selectedOwnershipFilter}
        onChangeOwnershipFilter={value => setSearchParams({ [SHORTLISTS_OWNERSHIP_FILTER]: value })}
        onSearchPlayersClick={() => navigate(`/${locale}/data-locker/players`)}
      />
    </div>
  );
};
